import React, { Component } from 'react';

const multiplier = 1;

const style = {
  marginBottom: 10,
};

class ReferralWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseX: null,
      mouseY: null,
      down: false,
      ...props.formData,
    };
  }

  componentDidMount() {
    this.updateIframe();
  }

  componentWillReceiveProps(props) {
    this.setState({
      ...props.formData,
    });
    this.updateIframe();
  }

  componentDidUpdate() {
    this.updateIframe();
  }

  updateIframe() {
    const { image } = this.state;
    if (this._iframe && this._iframe.contentDocument) {
      const document = this._iframe.contentDocument;
      document.head.innerHTML = `<style>
        img {
          width: 100%;
          height: 100%;
          object-fit: ${this.state.objectFit};
          object-position: ${this.state.x}% ${this.state.y}%;
          -webkit-touch-callout: none; /* iOS Safari */
          -webkit-user-select: none; /* Safari */
          -khtml-user-select: none; /* Konqueror HTML */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
        }
        body {
          pointer-events: none;
        }
      </style>`;
      document.body.outerHTML = '<body style="margin: 0px; overflow: hidden;"></body>';
      document.body.innerHTML = image !== null && image !== undefined ? image : '';
    }
  }

  move(event) {
    if (this.state.down) {
      const { onChange } = this.props;
      const { image, objectFit } = this.state;
      const diffX = this.state.mouseX - event.screenX;
      const diffY = this.state.mouseY - event.screenY;
      let x = this.state.x + (diffX * multiplier);
      let y = this.state.y + (diffY * multiplier);
      if (y > 100) { y = 100; }
      if (y < 0) { y = 0; }
      if (x > 100) { x = 100; }
      if (x < 0) { x = 0; }
      this.setState({
        mouseY: event.screenY,
        mouseX: event.screenX,
      }, () => onChange({
        x,
        y,
        image,
        objectFit,
      }));
    }
  }

  render() {
    const { onChange } = this.props;
    const { image, x, y, objectFit } = this.state;
    const valid = image !== null && image !== undefined && image !== '';
    return (
      <div>
        <div style={style}><b>Image Snippet</b></div>
        <div style={style}>
          Insert here the code of the referral image.
          This will take precedence over the normal image.
        </div>
        <textarea
          value={valid ? image : ''}
          onChange={e => onChange({ image: e.target.value, x, y, objectFit })}
          className="form-control"
          style={{ ...style, resize: 'vertical' }}
          rows={3}
        />
        <div style={style}>
          Choose the position properies of the referral image.
          You can move the image in the preview window below.
        </div>
        <label
          htmlFor="cover"
          style={{ marginRight: 10 }}
        >
          <input
            name="cover"
            type="radio"
            value="option1"
            checked={this.state.objectFit === 'cover'}
            onChange={e =>
              e.target.value && onChange({ x: 0, y: 0, objectFit: 'cover', image }, {})}
          />
          Cover
        </label>
        <label
          htmlFor="contain"
          style={{ marginRight: 10 }}
        >
          <input
            name="contain"
            type="radio"
            value="option1"
            checked={this.state.objectFit === 'contain'}
            onChange={e => e.target.value && onChange({ x: 50, y: 50, objectFit: 'contain', image })}
          />
          Contain
        </label>
        <div style={style}>
          Preview:
        </div>
        <div
          onMouseLeave={() => this.setState({ down: false })}
          onMouseMove={e => this.state.objectFit === 'cover' && this.move(e)}
          onMouseDown={e => this.setState({
            mouseX: e.screenX,
            mouseY: e.screenY,
            down: true,
          })}
          onMouseUp={() => this.setState({ down: false })}
          role="presentation"
          style={{
            display: valid ? 'block' : 'none',
            width: 300,
            height: 205,
            border: `${this.state.objectFit === 'cover' ? 'dashed' : 'solid'} #08c 1px`,
            marginTop: '20px',
            cursor: this.state.objectFit === 'cover' ? 'move' : null,
          }}
        >
          <iframe
            ref={(ref) => { this._iframe = ref; }}
            title="email preview"
            frameBorder={0}
            sandbox="allow-same-origin allow-top-navigation"
            scrolling="no"
            style={{
              width: '100%',
              height: '100%',
              pointerEvents: 'none',
            }}
          />
        </div>
      </div>
    );
  }
}

export default ReferralWidget;



// WEBPACK FOOTER //
// ./src/fields/ReferralField.js